
window.SFISI = (function (window, document, $, undefined) {
	'use strict';

	var app = {};

	/*
	Init = The medium state. Allows user scroll but not 100% of screen
	Open = User opened the ISI. Full screen on mobile, 3/4 on desktop.
	Closed = User closed ISI (or is returning). ISI sits at bottom of page with only title displaying.
	 */

	app.status = 'init';
	app.cName = (typeof isijso.cn !== "undefined" ? isijso.cn : 'sfisi');


	app.cache = function () {
		app.isi_main = $('.floating-isi');

		app.isi_embed = $('.embedded-isi');

		app.open = $('.isi-open');
		app.close = $('.isi-close');
		app.open_isi_links = $('.open-isi a');
		app.isi_embed_offset = 50;

		
		console.log(app.open_isi_links);
		

        // Clicking ISI Open buttons
        app.open.click(function (e) {
			e.preventDefault()
            var target = $('.isi.embedded-isi');
            $('html, body').animate({
                scrollTop: (
                    $(target).offset().top
                )
            }, 200, function () {
                $('.isi-floating').fadeOut();
            });

            e.preventDefault();
        });


		$('#mega-menu-item-35').on('click', function(){
			console.log('test');
			
		});
		


        $('.open-isi a').on('click', function (e) {
			e.preventDefault()
        
			console.log('test');
			
			var target = $('.isi.embedded-isi');
            $('html, body').animate({
                scrollTop: (
                    $(target).offset().top
                )
            }, 200, function () {
                $('.isi-floating').fadeOut();
            });

        });


	};

	app.init = function () {
		app.Cookie2 = Cookies;


		$('#mega-menu-item-35').on('click', function(){
			console.log('test');
			
		});

		app.cache();

		app.close.on('click', function (e) {
			e.preventDefault();

			$(document).trigger('sf3.isi.close', $(this), app.isi_main);

			app.isi_main.removeClass('open');
			app.isi_main.addClass('closed');

			$(document).trigger('sf3.isi.closed', $(this), app.isi_main);

			app.setCookie('closed');
		});

		app.open.on('click', function (e) {
			e.preventDefault();

			$(document).trigger('sf3.isi.show', $(this), app.isi_main);

			//app.isi_main.removeClass('closed');
			//app.isi_main.addClass('open-full');

			$(document).trigger('sf3.isi.shown', $(this), app.isi_main);

		});

// 		app.open_isi_links.on('click', function () {
// console.log('test');

// 			$(document).trigger('sf3.isi.links.show', $(this), app.isi_main);

// 			app.open.trigger('click');

// 			$(document).trigger('sf3.isi.links.shown', $(this), app.isi_main);
// 		});

		if (app.getCookie() !== "closed") {
			app.isi_main.removeClass('closed');
			$(document).trigger('sf3.isi.init.cookie', app.getCookie(), app.isi_main);
		}

		$(document).on('sf3.isi.closed sf3.isi.shown sf3.isi.init', function(isiEl){
			// app.bodyMargin();
			app.calculateEmbedOffset();
			$(document).trigger('sf3.isi.changed', app.isi_main);
		});

		$(window).on('resize', function(){
			// app.bodyMargin();
			app.calculateEmbedOffset();
		})


		$(document).trigger('sf3.isi.init', app.isi_main);
		$(window).scroll(app.maybeHideFloatingIsi);
		app.maybeHideFloatingIsi();

	};

	app.calculateEmbedOffset = function() {
		app.isi_embed_offset = app.isi_embed.offset().top -  $(window).height();
		//app.isi_embed_offset = 100;
	}

	app.maybeHideFloatingIsi = function() {

		if($(window).scrollTop() > 0 && !app.isi_main.hasClass('open-full')) {
			//app.isi_main.addClass('closed');
		}

		if(app.isi_embed_offset) {
			if($(window).scrollTop() > app.isi_embed_offset) {
				app.isi_main.fadeOut()
			} else {
				app.isi_main.fadeIn()
			}
		}
	}

	app.bodyMargin = function(){
		if(!app.isi_main.hasClass('open') || !app.isi_main.hasClass('closed')){
			$('body').css('padding-bottom', app.isi_main.height())
		} else {
			$('body').css('padding-bottom', '');
		}
	};

	app.setCookie = function (value) {
		app.Cookie2.set(app.cName, value);
	};

	app.getCookie = function () {

		return app.Cookie2.get(app.cName);

	};

	$(document).ready(function () {
		if ($('.isi').length > 0) {
			app.init();
		}
	});
	return app;

})(window, document, jQuery);
